import { getAnalytics } from "firebase/analytics";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { LoadingPage } from "../components/commons/LoadingPage";
import Footer from "../components/footer";
import Lp from "../components/lp";
import { RootContext } from "../contexts/rootContext";
import { app } from "../lib/firebaseConfig";
import { NAVBAR_LINK } from "../utils/enum";

// getStaticPropsで取得したデータをここのpropsとしてもらっている
const Home: NextPage = ({ allPostsData }: any) => {
  const { state } = useContext(RootContext);
  const authResolved = state?.authResolved;
  const firebaseUser = state?.firebaseUser;
  const router = useRouter();

  useEffect(() => {
    self.addEventListener("activate", (event: any) => {
      // console.log("event useEffect self.addEventListener", event);
      event.waitUntil(
        caches.keys().then((cacheNames) => {
          // console.log("cacheNames useEffect self.addEventListener", cacheNames);
          return Promise.all(
            cacheNames.map((cacheName) => {
              // 削除したいファイルのキャッシュ名を指定する
              if (
                cacheName.includes(
                  "/index.html?__WB_REVISION__=56417e6a3e96d6ce500997132211260b"
                )
              ) {
                return caches.delete(cacheName);
              }
            })
          );
        })
      );
    });
  }, []);

  useEffect(() => {
    const isGtmMode =
      process.env.NODE_ENV === "production" && Boolean(process.env.NEXT_PUBLIC_GTM_ID);

    if (isGtmMode) return;

    // ブラウザ以外でanalyticsの初期化ができないのでanalyticsはブラウザのrootで初期化している
    // ref: https://firebase.google.com/docs/web/environments-js-sdk#other_environments
    getAnalytics(app);
  }, []);

  useEffect(() => {
    if (authResolved && firebaseUser && router.pathname === NAVBAR_LINK.defaultPage) {
      router.replace(NAVBAR_LINK.home);
    }
  }, [authResolved, firebaseUser, router]);

  if (!authResolved || firebaseUser) {
    return <LoadingPage />;
  }

  return (
    <>
      <Lp />
      <Footer />
    </>
  );
};

export default Home;
